var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3966_102387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1148 42.7355C22.1148 42.7355 19.0627 42.7355 19.0627 39.6833C19.0627 36.6312 22.1148 27.4749 34.3232 27.4749C46.5317 27.4749 49.5838 36.6312 49.5838 39.6833C49.5838 42.7355 46.5317 42.7355 46.5317 42.7355H22.1148ZM34.3232 24.4228C36.7516 24.4228 39.0806 23.4581 40.7977 21.741C42.5149 20.0238 43.4796 17.6949 43.4796 15.2664C43.4796 12.838 42.5149 10.5091 40.7977 8.79194C39.0806 7.07479 36.7516 6.11011 34.3232 6.11011C31.8948 6.11011 29.5659 7.07479 27.8487 8.79194C26.1316 10.5091 25.1669 12.838 25.1669 15.2664C25.1669 17.6949 26.1316 20.0238 27.8487 21.741C29.5659 23.4581 31.8948 24.4228 34.3232 24.4228Z",
    fill: "#343A40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6698 42.7355C16.2174 41.7826 15.9917 40.738 16.0106 39.6833C16.0106 35.5477 18.086 31.29 21.9194 28.3295C20.0061 27.7399 18.0126 27.4516 16.0106 27.4749C3.80211 27.4749 0.75 36.6312 0.75 39.6833C0.75 42.7355 3.80211 42.7355 3.80211 42.7355H16.6698Z",
    fill: "#343A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4845 24.4228C16.5082 24.4228 18.449 23.6189 19.8799 22.1879C21.3109 20.757 22.1148 18.8162 22.1148 16.7925C22.1148 14.7688 21.3109 12.828 19.8799 11.3971C18.449 9.96612 16.5082 9.16222 14.4845 9.16222C12.4608 9.16222 10.52 9.96612 9.08908 11.3971C7.65813 12.828 6.85422 14.7688 6.85422 16.7925C6.85422 18.8162 7.65813 20.757 9.08908 22.1879C10.52 23.6189 12.4608 24.4228 14.4845 24.4228Z",
    fill: "#343A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3966_102387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.8338,
    height: 48.8338,
    fill: "white",
    transform: "translate(0.75 0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleGray);
export default __webpack_public_path__ + "static/media/PeopleGray.2031bfe686a52fa272aa4649b249d1a7.svg";
export { ForwardRef as ReactComponent };